import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { StockCardCategoriesQuery } from '../../../../generated/graphql';
import WarehouseCategoriesDetailCard from './WarehouseCategoriesDetailCard';

interface WarehouseCategoriesListViewProps {
    stockCardCategories: StockCardCategoriesQuery['stockCardCategories'];
}

const WarehouseCategoriesListView = ({ stockCardCategories }: WarehouseCategoriesListViewProps) => (
    <Grid container justify="center" alignItems="center">
        <Grid item lg={6} md={8} sm={12} xs={12}>
            {stockCardCategories.map(({ id, name }) => (
                <Box
                    key={id}
                    width="100%"
                    marginBottom={4}
                >
                    <WarehouseCategoriesDetailCard
                        id={id}
                        name={name}
                    />
                </Box>
        ))}
        </Grid>
    </Grid>
);

export default WarehouseCategoriesListView;
